// extracted by mini-css-extract-plugin
module.exports = {"swiper":"DraftArtworkImages_swiper__jv_sQ"};